import React, { useState, useEffect } from 'react';
import { useAdminAuth } from '../context/AdminAuthContext';
import {
  getAdminBlogCategories, getAdminBlogPosts, getAdminBlogPost,
  saveAdminBlogPost, deleteAdminBlogPost
} from '../api/adminApi';
import { BASE_URL } from './../config';

function formatDate(dateStr) {
  return new Date(dateStr).toLocaleDateString('fa-IR');
}

const COVER_BASE_URL = `${BASE_URL}/blog-covers`;
export const AdminBlog = () => {
  const { token } = useAdminAuth();
  const [categories, setCategories] = useState([]);
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  const [articleFile, setArticleFile] = useState(null);
  const [existingFileName, setExistingFileName] = useState(null);

  const [categoryFilter, setCategoryFilter] = useState('');
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [showEditor, setShowEditor] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [formState, setFormState] = useState({
    categoryId: '', title: '', summary: '', content: '', isPublished: true
  });
  const [coverFile, setCoverFile] = useState(null);
  const [existingCover, setExistingCover] = useState(null);
  const [saving, setSaving] = useState(false);

  const [deleteTarget, setDeleteTarget] = useState(null);
  const [toast, setToast] = useState({ show: false, type: 'success', message: '' });

  useEffect(() => {
    async function loadCategories() {
      const result = await getAdminBlogCategories(token);
      if (result.success) setCategories(result.data.categories);
    }
    loadCategories();
    // eslint-disable-next-line
  }, []);

  const loadPosts = async () => {
    setLoading(true);
    const result = await getAdminBlogPosts(token, categoryFilter, search, page);
    setLoading(false);

    if (result.success) {
      setPosts(result.data.posts);
      setTotalPages(result.data.totalPages);
    } else {
      setToast({ show: true, type: 'error', message: result.message });
    }
  };

  useEffect(() => {
    loadPosts();
    // eslint-disable-next-line
  }, [categoryFilter, page]);

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    setPage(1);
    loadPosts();
  };

const openAddModal = () => {
  setEditingId(null);
  setFormState({ categoryId: categories[0]?.id || '', title: '', summary: '', isPublished: true });
  setCoverFile(null);
  setExistingCover(null);
  setArticleFile(null);
  setExistingFileName(null);
  setShowEditor(true);
};

  const openEditModal = async (postId) => {
  const result = await getAdminBlogPost(token, postId);
  if (result.success) {
    const post = result.data.post;
    setEditingId(post.id);
    setFormState({
      categoryId: post.category_id,
      title: post.title,
      summary: post.summary || '',
      isPublished: !!post.is_published
    });
    setCoverFile(null);
    setExistingCover(post.cover_image);
    setArticleFile(null);
    setExistingFileName(post.file_name);
    setShowEditor(true);
  } else {
    setToast({ show: true, type: 'error', message: result.message });
  }
};

  const handleFormChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormState({ ...formState, [name]: type === 'checkbox' ? checked : value });
  };

const handleSave = async () => {
  if (!formState.categoryId || !formState.title.trim()) {
    setToast({ show: true, type: 'error', message: 'دسته‌بندی و عنوان الزامی هستند.' });
    return;
  }

  if (!editingId && !articleFile) {
    setToast({ show: true, type: 'error', message: 'انتخاب فایل آموزشی الزامی است.' });
    return;
  }

  setSaving(true);
  const result = await saveAdminBlogPost(token, {
    id: editingId,
    categoryId: formState.categoryId,
    title: formState.title,
    summary: formState.summary,
    isPublished: formState.isPublished,
    coverFile,
    articleFile
  });
  setSaving(false);

  if (result.success) {
    setToast({ show: true, type: 'success', message: result.data.message });
    setShowEditor(false);
    loadPosts();
  } else {
    setToast({ show: true, type: 'error', message: result.message });
  }
};

  const handleDelete = async () => {
    if (!deleteTarget) return;
    const result = await deleteAdminBlogPost(token, deleteTarget.id);
    setDeleteTarget(null);

    if (result.success) {
      setToast({ show: true, type: 'success', message: result.data.message });
      loadPosts();
    } else {
      setToast({ show: true, type: 'error', message: result.message });
    }
  };

  const inputStyle = {
    border: '1px solid white',
    backgroundColor: 'transparent',
    color: 'white',
    borderRadius: 8,
    height: 40,
    width: '100%'
  };

  return (
    <div dir="rtl" style={{ padding: 24 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20, flexWrap: 'wrap', gap: 10 }}>
        <h2 className="w3-text-white">مدیریت وبلاگ</h2>
        <button
          onClick={openAddModal}
          className="w3-button w3-round-xxlarge"
          style={{ color: '#15ff00', border: '2px solid #2980b9', backgroundColor: 'transparent', display: 'flex', alignItems: 'center' }}
        >
          <i className="material-icons w3-margin-left">add</i>
          افزودن مقاله جدید
        </button>
      </div>

      {/* فیلترها */}
      <div style={{ display: 'flex', gap: 14, marginBottom: 20, flexWrap: 'wrap', alignItems: 'flex-end' }}>
        <div style={{ minWidth: 220 }}>
          <label className="w3-text-white">دسته‌بندی</label>
          <select
            value={categoryFilter}
            onChange={(e) => { setCategoryFilter(e.target.value); setPage(1); }}
            className="w3-select"
            style={{ ...inputStyle, backgroundColor: '#263238' }}
          >
            <option value="">همه دسته‌ها</option>
            {categories.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
          </select>
        </div>

        <form onSubmit={handleSearchSubmit} style={{ display: 'flex', gap: 10, minWidth: 260 }}>
          <input
            type="text"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="جستجو در عنوان مقالات..."
            className="w3-input"
            style={{ ...inputStyle, backgroundColor: '#263238' }}
          />
          <button type="submit" className="w3-button" style={{ color: '#4FC3F7', border: '2px solid #2980b9', backgroundColor: 'transparent', borderRadius: 8, height: 40 }}>
            <i className="material-icons" style={{ verticalAlign: 'middle' }}>search</i>
          </button>
        </form>
      </div>

      {/* لیست مقالات */}
      <div className="w3-card-4 w3-round-large" style={{ backgroundColor: '#263238', padding: 10, overflowX: 'auto' }}>
        {loading ? (
          <p className="w3-text-grey w3-center" style={{ padding: 30 }}>در حال بارگذاری...</p>
        ) : posts.length === 0 ? (
          <p className="w3-text-grey w3-center" style={{ padding: 30 }}>مقاله‌ای یافت نشد.</p>
        ) : (
          <table className="w3-table w3-text-white" style={{ width: '100%', minWidth: 700 }}>
            <thead>
              <tr style={{ borderBottom: '1px solid #37474F' }}>
                <th style={{ textAlign: 'right', padding: 10 }}>تصویر</th>
                <th style={{ textAlign: 'right', padding: 10 }}>عنوان</th>
                <th style={{ textAlign: 'right', padding: 10 }}>دسته‌بندی</th>
                <th style={{ textAlign: 'right', padding: 10 }}>بازدید</th>
                <th style={{ textAlign: 'right', padding: 10 }}>تاریخ</th>
                <th style={{ textAlign: 'right', padding: 10 }}>وضعیت</th>
                <th style={{ textAlign: 'left', padding: 10 }}>عملیات</th>
              </tr>
            </thead>
            <tbody>
              {posts.map((post) => (
                <tr key={post.id} style={{ borderBottom: '1px solid #263238' }}>
                  <td style={{ padding: 10 }}>
                    {post.cover_image ? (
                      <img
                        src={`${COVER_BASE_URL}/${post.cover_image}`}
                        alt=""
                        style={{ width: 50, height: 40, objectFit: 'cover', borderRadius: 6 }}
                      />
                    ) : (
                      <div style={{ width: 50, height: 40, backgroundColor: '#1c2529', borderRadius: 6, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <i className="material-icons" style={{ fontSize: 18, color: '#37474F' }}>image</i>
                      </div>
                    )}
                  </td>
                  <td style={{ padding: 10, maxWidth: 220 }}>{post.title}</td>
                  <td style={{ padding: 10, fontSize: 13 }}>{post.category_name}</td>
                  <td style={{ padding: 10 }}>{post.views}</td>
                  <td style={{ padding: 10, fontSize: 12 }}>{formatDate(post.created_at)}</td>
                  <td style={{ padding: 10 }}>
                    {post.is_published ? (
                      <span style={{ color: '#15ff00', fontSize: 12 }}>منتشرشده</span>
                    ) : (
                      <span style={{ color: '#ff9800', fontSize: 12 }}>پیش‌نویس</span>
                    )}
                  </td>
                  <td style={{ padding: 10, textAlign: 'left', whiteSpace: 'nowrap' }}>
                    <button onClick={() => openEditModal(post.id)} className="w3-button" style={{ color: '#4FC3F7' }}>
                      <i className="material-icons">edit</i>
                    </button>
                    <button onClick={() => setDeleteTarget(post)} className="w3-button" style={{ color: '#ff0000' }}>
                      <i className="material-icons">delete</i>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {/* صفحه‌بندی */}
      {totalPages > 1 && (
        <div style={{ display: 'flex', justifyContent: 'center', gap: 6, marginTop: 20 }}>
          {Array.from({ length: totalPages }, (_, i) => i + 1).map((p) => (
            <button
              key={p}
              onClick={() => setPage(p)}
              className="w3-button w3-round"
              style={{ minWidth: 36, backgroundColor: p === page ? '#2980b9' : 'transparent', color: 'white', border: '1px solid #37474F' }}
            >
              {p}
            </button>
          ))}
        </div>
      )}

      {/* مودال ویرایشگر مقاله */}
      {showEditor && (
        <div className="w3-modal" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 999, padding: 20 }}>
          <div
            className="w3-card-4 w3-animate-zoom"
            style={{ backgroundColor: '#263238', borderRadius: 16, width: 600, maxWidth: '95%', maxHeight: '90vh', overflowY: 'auto' }}
          >
            <div className="w3-container w3-padding" style={{ borderBottom: '1px solid #37474F', position: 'sticky', top: 0, backgroundColor: '#263238', zIndex: 1 }}>
              <span onClick={() => setShowEditor(false)} className="w3-button w3-display-topright" style={{ color: 'white' }}>&times;</span>
              <h4 className="w3-text-white" style={{ margin: 0 }}>{editingId ? 'ویرایش مقاله' : 'افزودن مقاله جدید'}</h4>
            </div>

            <div className="w3-container w3-padding">
              <label className="w3-text-white">دسته‌بندی</label>
              <select
                name="categoryId"
                value={formState.categoryId}
                onChange={handleFormChange}
                className="w3-select"
                style={{ ...inputStyle, marginBottom: 14 }}
              >
                {categories.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
              </select>

              <label className="w3-text-white">عنوان مقاله</label>
              <input
                type="text"
                name="title"
                value={formState.title}
                onChange={handleFormChange}
                className="w3-input"
                style={{ ...inputStyle, marginBottom: 14 }}
              />

              <label className="w3-text-white">خلاصه (نمایش در کارت مقاله)</label>
              <textarea
                name="summary"
                value={formState.summary}
                onChange={handleFormChange}
                className="w3-input"
                style={{ ...inputStyle, minHeight: 60, marginBottom: 14, paddingTop: 8 }}
              />

             <label className="w3-text-white">فایل آموزشی (PDF, Word یا PowerPoint)</label>
{existingFileName && !articleFile && (
  <div style={{ marginBottom: 8, display: 'flex', alignItems: 'center', color: '#4FC3F7', fontSize: 13 }}>
    <i className="material-icons" style={{ fontSize: 18, marginLeft: 6 }}>attach_file</i>
    فایل فعلی: {existingFileName}
  </div>
)}
<input
  type="file"
  accept=".pdf,.doc,.docx,.ppt,.pptx"
  onChange={(e) => setArticleFile(e.target.files[0])}
  className="w3-input w3-text-white"
  style={{ ...inputStyle, padding: '6px', marginBottom: 14 }}
/>

              <label className="w3-text-white">تصویر کاور</label>
              {existingCover && !coverFile && (
                <div style={{ marginBottom: 8 }}>
                  <img src={`${COVER_BASE_URL}/${existingCover}`} alt="" style={{ maxHeight: 120, borderRadius: 8 }} />
                </div>
              )}
              <input
                type="file"
                accept="image/jpeg,image/png,image/webp"
                onChange={(e) => setCoverFile(e.target.files[0])}
                className="w3-input w3-text-white"
                style={{ ...inputStyle, padding: '6px', marginBottom: 14 }}
              />

              <label className="w3-text-white" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <input
                  type="checkbox"
                  name="isPublished"
                  checked={formState.isPublished}
                  onChange={handleFormChange}
                />
                منتشر شود (در صورت غیرفعال بودن، به‌عنوان پیش‌نویس ذخیره می‌شود)
              </label>
            </div>

            <div className="w3-container w3-padding" style={{ paddingBottom: 16 }}>
              <button
                onClick={handleSave}
                disabled={saving}
                className="w3-button w3-block"
                style={{ color: '#15ff00', border: '2px solid #2980b9', backgroundColor: 'transparent', borderRadius: 10 }}
              >
                {saving ? 'در حال ذخیره...' : 'ذخیره مقاله'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* تایید حذف */}
      {deleteTarget && (
        <div className="w3-modal" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 999 }}>
          <div className="w3-card-4 w3-animate-zoom" style={{ backgroundColor: '#263238', borderRadius: 16, width: 340, maxWidth: '90%', overflow: 'hidden' }}>
            <div className="w3-container w3-padding" style={{ backgroundColor: '#ff000022', borderBottom: '2px solid #ff0000' }}>
              <h4 className="w3-text-white" style={{ margin: 0 }}>تایید حذف</h4>
            </div>
            <div className="w3-container w3-padding">
              <p className="w3-text-white">آیا از حذف مقاله «{deleteTarget.title}» مطمئن هستید؟</p>
            </div>
            <div className="w3-container w3-padding" style={{ paddingBottom: 16, display: 'flex', gap: 10 }}>
              <button onClick={handleDelete} className="w3-button" style={{ flex: 1, color: 'white', backgroundColor: '#ff0000', borderRadius: 10 }}>
                بله، حذف شود
              </button>
              <button onClick={() => setDeleteTarget(null)} className="w3-button" style={{ flex: 1, color: '#15ff00', border: '2px solid #15ff00', backgroundColor: 'transparent', borderRadius: 10 }}>
                انصراف
              </button>
            </div>
          </div>
        </div>
      )}

      {/* پیام موفقیت/خطا */}
      {toast.show && (
        <div className="w3-modal" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 999 }}>
          <div className="w3-card-4 w3-animate-zoom" style={{ backgroundColor: '#263238', borderRadius: 16, width: 320, maxWidth: '90%', overflow: 'hidden' }}>
            <div
              className="w3-container w3-padding"
              style={{ backgroundColor: toast.type === 'success' ? '#15ff0022' : '#ff000022', borderBottom: `2px solid ${toast.type === 'success' ? '#15ff00' : '#ff0000'}` }}
            >
              <span onClick={() => setToast({ ...toast, show: false })} className="w3-button w3-display-topright" style={{ color: 'white' }}>&times;</span>
              <h4 className="w3-text-white" style={{ margin: 0 }}>{toast.type === 'success' ? '✅ موفقیت' : '❌ خطا'}</h4>
            </div>
            <div className="w3-container w3-padding"><p className="w3-text-white">{toast.message}</p></div>
            <div className="w3-container w3-padding" style={{ paddingBottom: 16 }}>
              <button
                onClick={() => setToast({ ...toast, show: false })}
                className="w3-button w3-block"
                style={{ color: toast.type === 'success' ? '#15ff00' : '#ff0000', border: `2px solid ${toast.type === 'success' ? '#15ff00' : '#ff0000'}`, backgroundColor: 'transparent', borderRadius: 10 }}
              >
                باشه
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};